import React from 'react';
import { Box, Container, Divider, Link, Paper, Stack, Typography } from '@mui/material';

const Support = () => {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, sm: 6 } }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'left',
        }}
      >
        <Stack spacing={1} sx={{ mb: 3 }}>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
            Support
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
        </Stack>

        <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }} paragraph>
          Need help with Lexory? We’re here to help you get back to reading and translating as quickly as possible.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Stack spacing={3}>
          <Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
              Contact
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }} paragraph>
              Email us at{' '}
              <Link href="mailto:lexory@proton.me" underline="hover">
                lexory@proton.me
              </Link>
              .
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
              Please include the email address you use for Lexory, a short description of what you’re trying to do, and any error message you see.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
              Common issues
            </Typography>
            <Box component="ul" sx={{ mt: 0, mb: 0, pl: 3, '& li': { mb: 1 } }}>
              <li>
                <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
                  Login problems: confirm you’re using the same email you signed up with, and try requesting a password reset.
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
                  Password reset: if your reset link expired, request a new one from the login page.
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
                  Billing and Premium: if checkout doesn’t complete, try a different payment method or contact us and we’ll help.
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
                  Usage limits: your available usage depends on your plan. Check the Usage page for current status.
                </Typography>
              </li>
            </Box>
          </Box>

          <Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
              What we can help with
            </Typography>
            <Box component="ul" sx={{ mt: 0, mb: 0, pl: 3, '& li': { mb: 1 } }}>
              <li>
                <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
                  Account access and password resets
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
                  Billing questions, invoices, and subscription issues
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
                  Bug reports and feature requests
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
                  Privacy questions and data requests
                </Typography>
              </li>
            </Box>
          </Box>

          <Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
              Response times
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.9, fontSize: '1.05rem' }}>
              We aim to respond within 1–2 business days. During high-volume periods, responses may take longer.
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
};

export default Support;
